import React from 'react';
import EmptyStateImage from 'assets/images/gift-card-empty-state.png';
import { Button } from '@cokitchen/cokitchen-components';
import { useNavigate } from 'react-router-dom';
import { ROUTE_KEYS } from 'utils/constants';

const EmptyState = () => {
  const navigate = useNavigate();
  return (
    <div className='flex justify-center items-center'>
      <div className='space-y-4 flex flex-col items-center '>
        <img src={EmptyStateImage} alt='Empty-state' />
        <p className=' text-sm  font-medium text-[#1A1A1A] mx-auto'>
          You haven’t added any categories 😅
        </p>
        <Button
          onClick={() => navigate(ROUTE_KEYS.CREATE_GIFTCARD_CATEGORY)}
          color='primary'
          variant='block'
          className='h-[46px] w-[151px] text-sm'>
          Create one now
        </Button>
      </div>
    </div>
  );
};

export default EmptyState;
